export const getPatientReferralUrl = () => 'patient_referral';
